import React, { useState } from 'react';
import NewStageForm from '../../../../NewStageForm';
import { Edit16 } from '@carbon/icons-react';
import { OverflowMenu, OverflowMenuItem } from 'carbon-components-react';
import DeleteteStage from './DeleteStage';
import funcTranslateHelper from '../../../../../../../i18next/funcTranslateHelper';

export default function AddAsset ({ stage, configFile, setConfigFile, setOpenNotication }) {
  const [form, setForm] = useState(false);
  const [deleteStage, setDeleteStage] = useState(false);

  return (
    <>
      <OverflowMenu renderIcon={Edit16} className='stage-dropdown-button'>
        <OverflowMenuItem itemText={funcTranslateHelper('Editar')} onClick={() => setForm(true)} />
        <OverflowMenuItem itemText={funcTranslateHelper('Eliminar')} hasDivider isDelete onClick={() => setDeleteStage(true)} />
      </OverflowMenu>

      {
        form &&
          <NewStageForm
            setConfigFile={setConfigFile}
            setOpenNotication={setOpenNotication}
            stage={stage}
            open={form}
            handleClose={setForm}
            configFile={configFile}
          />
      }
      {
        deleteStage &&
          <DeleteteStage
            open={deleteStage}
            handleClose={setDeleteStage}
            stage={stage}
            configFile={configFile}
            setConfigFile={setConfigFile}
          />
      }
    </>
  );
}
